import Service from "../Service";
const resource = "TrsBudget/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "paginate", parameters, {
      params: { requestID: requestID },
    });
  },

  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID },
    });
  },

  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID: requestID },
    });
  },

  report(parameters, requestID) {
    return Service.post(resource + "report", parameters, {
      params: { requestID: requestID },
    });
  },

  saveProject(parameters, requestID) {
    return Service.post(resource + "saveProject", parameters, {
      params: { requestID: requestID },
    });
  },

  changeProjectLock(parameters, requestID) {
    return Service.post(resource + "changeProjectLock", parameters, {
      params: { requestID: requestID },
    });
  },
};
